import { INPUT_WIZARD_STEPS, INPUT_WIZARD_FLOWS } from "components/inputs/InputSetupWizard/types";
export const INPUT_SETUP_MODE_FEATURE_FLAG = "setup_mode";
export default INPUT_SETUP_MODE_FEATURE_FLAG;
export const OPEN_FLOW_STEPS = {
  [INPUT_WIZARD_FLOWS.ILLUMINATE]: [INPUT_WIZARD_STEPS.START_INPUT, INPUT_WIZARD_STEPS.INPUT_DIAGNOSIS],
  [INPUT_WIZARD_FLOWS.NON_ILLUMINATE]: [
    INPUT_WIZARD_STEPS.SETUP_ROUTING,
    INPUT_WIZARD_STEPS.START_INPUT,
    INPUT_WIZARD_STEPS.INPUT_DIAGNOSIS
  ]
};
